/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { commitMutation, graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';

import environment from '../RelayEnv';

const mutation = graphql`
  mutation SendMutation($input: SendInput!) {
    send(input: $input) {
      messageEdge {
        node {
          id
          ...Message_message
          channel {
            id
          }
        }
      }
    }
  }
`;

const commit = function(id, msg, onSuccess) {
  const variables = {
    input: msg,
  };

  return commitMutation(environment, {
    mutation,
    variables,
    updater: store => {
      const payload = store.getRootField('send');
      const messageEdge = payload.getLinkedRecord('messageEdge');
      if (!messageEdge) return;

      const node = messageEdge.getLinkedRecord('node');
      if (!node) return;

      const channel = node.getLinkedRecord('channel');

      // Add to channel's messages connection if it's a channel message
      if (channel != null) {
        const channelID = channel.getValue('id');
        const channelProxy = store.get(channelID);
        if (channelProxy != null) {
          const conn = ConnectionHandler.getConnection(
            channelProxy,
            'Messages_messages',
          );
          if (conn != null) {
            const newEdge = ConnectionHandler.createEdge(
              store,
              conn,
              node,
              'MessageEdge',
            );
            ConnectionHandler.insertEdgeBefore(conn, newEdge);
          }
        }
      }

      // Add to viewer's user messages connection
      const viewerProxy = store.getRoot().getLinkedRecord('viewer');
      if (viewerProxy != null) {
        const conn = ConnectionHandler.getConnection(
          viewerProxy,
          'UserMessages_messages',
        );
        if (conn != null) {
          const newEdge = ConnectionHandler.createEdge(
            store,
            conn,
            node,
            'MessageEdge',
          );
          ConnectionHandler.insertEdgeBefore(conn, newEdge);
        }
      }
    },
    onCompleted: onSuccess,
  });
};

export default { commit };
